export default {
  title: "Bitácora de Acceso"
  , filtros: "Filtros de Búsqueda"
  , form: {
    fecha: { th: "Fecha y hora" }
    , modulo: { th: "Módulo" }
    , url: { th: "URL" }
    , addres: { th: "IP de Solicitud" }
  }
  , errors: {
    BD4000: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , WS4000: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , JS4000: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , CR4000: { text: "Ocurrió un error en el catálogo de Bitácora" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/bitacoras/bitacora.js